import { createStore, applyMiddleware, compose } from "redux";
import { routerMiddleware } from "react-router-redux";
import { thunk } from "redux-thunk";
import { createBrowserHistory as createHistory } from "history";

import rootReducer from "./rootReducer";
import { loadState, saveState } from "../redux/sessionstorage";

// var createHistory = require("history").createBrowserHistory;
export const history = createHistory();

const persistedState = loadState();
const enhancers = [];
const middleware = [thunk, routerMiddleware(history)];

if (process.env.NODE_ENV === "development") {
  const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__;

  if (typeof devToolsExtension === "function") {
    enhancers.push(devToolsExtension());
  }
}

const composedEnhancers = compose(
  applyMiddleware(...middleware),
  ...enhancers
);

const store = createStore(
  rootReducer,
  persistedState,
  composedEnhancers
);

// ========================================================
// Persist data on page refresh
// ========================================================
store.subscribe(() => {
  saveState(store.getState());
});

export default store;
